import { auth } from "../firebase/Config";

const API_BASE = process.env.REACT_APP_API_URL || "";

/**
 * Obtiene el ID Token actual del usuario autenticado en Firebase.
 */
const getAuthToken = async () => {
  if (auth.currentUser) {
    return await auth.currentUser.getIdToken();
  }
  return "";
};

/**
 * Solicita el envío de un código OTP por WhatsApp.
 * @param {string} telefono - Número de celular de 9 dígitos.
 */
export const solicitarCodigoWhatsApp = async (telefono) => {
  const token = await getAuthToken();
  const url = `${API_BASE}/api/v1/verificacion/whatsapp/enviar-codigo`;
  console.log("Solicitando código OTP para el teléfono:", telefono);
  console.log("url de la API:", url);

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ telefono }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Error al enviar el código de verificación.");
  }

  return data;
};

/**
 * Valida el código OTP ingresado por el usuario.
 * @param {string} telefono - Número de celular de 9 dígitos.
 * @param {string} codigo - Código de 6 dígitos.
 */
export const validarCodigoWhatsApp = async (telefono, codigo) => {
  const token = await getAuthToken();
  const url = `${API_BASE}/api/v1/verificacion/whatsapp/validar-codigo`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ telefono, codigo }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Código de verificación incorrecto o expirado.");
  }

  return data;
};
